import {
  Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChange,
  ViewChild
} from '@angular/core';
import {FileService} from '../file.service';

@Component({
  selector: 'app-load-file',
  templateUrl: './file-load.component.html',
  styleUrls: ['./file-load.component.css']
})
export class FileLoadComponent implements OnInit {

  allowedFileExt: Array<String>;
  @Output() onFileLoad = new EventEmitter<Array<File>>();
  @Input() fileToDeleteName: string;
  @ViewChild('fileInput') fileInput: ElementRef;
  files: Array<File>;
  // Не отображает иконку прикрепления файлов, если не удалось получить настройки
  gotFileExtSettings: boolean;

  constructor(private fileService: FileService) {
    this.files = [];
    this.gotFileExtSettings = false;
  }

  ngOnInit() {
    this.getFileExtensionSettings();
  }

  ngOnChanges(changes: {[propKey: string]: SimpleChange}) {
    console.debug("On changes deletet file:", changes.fileToDeleteName);
    if(changes.fileToDeleteName != null) {
      this.files = this.files.filter(f => f.name != changes.fileToDeleteName.currentValue);
      this.onFileLoad.emit(this.files);
    }
  }

  async getFileExtensionSettings() {
    this.fileService.getFileExtSettings().then(
      (data) => {
        this.allowedFileExt = data;
        this.gotFileExtSettings = data._body != "";
      }, (error) => {
        this.gotFileExtSettings = false;
      }
    )
  }

  async upload() {
    let inputEl: HTMLInputElement = this.fileInput.nativeElement;
    let files = null;
    console.debug(" UPLOADING FILES!!!", inputEl.files);
    await this.fileService.upload(inputEl, this.allowedFileExt, this.files.length).then((data) => {
     files = data;
    });

    if(files != null) {
      for(let file of files) {
        this.files.push(file);
      }
    }
    console.debug("Uploaded files:", this.files);
    this.onFileLoad.emit(this.files);
  }

  deleteAllFiles() {
    this.files = [];
    this.onFileLoad.emit(this.files);
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/shared-module/file/file-load/file-load.component.ts